import {ActionIcon, Menu} from "@mantine/core";
import {IconDotsVertical} from "@tabler/icons-react";

export const CompanyPageMenu = ({create}: { create: () => void }) => {
  return (
    <Menu width={250}>
      <Menu.Target>
        <ActionIcon variant="transparent">
          <IconDotsVertical/>
        </ActionIcon>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Label>Zarządzanie</Menu.Label>
        <Menu.Item
          onClick={create}
          children="Utwórz"
        />
      </Menu.Dropdown>
    </Menu>
  )
}